import { render } from "./DashboardOfferUser.vue?vue&type=template&id=6bf1eb14&scoped=true"
import script from "./DashboardOfferUser.vue?vue&type=script&lang=ts"
export * from "./DashboardOfferUser.vue?vue&type=script&lang=ts"

import "./DashboardOfferUser.vue?vue&type=style&index=0&id=6bf1eb14&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bf1eb14"

export default script